/**
 * Districts — MechCorp City's unlock (MINIGAME_PROPOSALS O10). You liberated
 * a city; survivors move into the one walking on your legs. Population
 * arrives slowly with wave progress; assign citizens to districts for small
 * global multipliers. Housing raises the other districts' capacity.
 *
 * Design call: multiplicative with a +20 percent TOTAL cap — and it quietly
 * seeds the squad/ally endgame (districts can later staff pilots).
 */

export type DistrictId = 'housing' | 'factory' | 'lab' | 'arcade';

export interface DistrictDef {
  id: DistrictId;
  name: string;
  flavor: string;
  /** What the district does (display). */
  effectLabel: string;
}

export const DISTRICTS: DistrictDef[] = [
  { id: 'housing', name: 'Housing', flavor: 'Apartments with a view of the apocalypse.', effectLabel: '+2 capacity to every other district per resident' },
  { id: 'factory', name: 'Factory', flavor: 'They build the things that build the things.', effectLabel: '+0.4% Scrap per worker' },
  { id: 'lab', name: 'Lab', flavor: 'Reverse-engineering MechCorp out of spite.', effectLabel: '+0.4% Components per worker' },
  { id: 'arcade', name: 'Arcade', flavor: 'Morale matters. Pets love the claw machine.', effectLabel: '+0.4% pet drop rate per worker' },
];

export function getDistrict(id: string): DistrictDef | undefined {
  return DISTRICTS.find((d) => d.id === id);
}

/** Citizens already aboard when the city powers up. */
export const POP_BASE = 20;
/** New citizens rescued per wave pushed past the unlock frontier. */
export const POP_PER_WAVE = 3;

/** Working-district capacity: base + this per Housing resident. */
export const DISTRICT_CAP_BASE = 10;
export const CAP_PER_HOUSING = 2;

/** Bonus per assigned worker, the per-district cap, and the total cap. */
export const BONUS_PER_WORKER = 0.004;
export const DISTRICT_BONUS_CAP = 0.12;
export const TOTAL_BONUS_CAP = 0.2;
